import React from 'react';
import styles from './MenuCheckbox.module.scss';

interface MenuCheckboxProps {
  isSelected: boolean;
  isDisabled?: boolean;
  onChange?: (selected: boolean) => void;
}

const MenuCheckbox: React.FC<MenuCheckboxProps> = ({
  isSelected,
  isDisabled = false,
  onChange
}) => {
  const handleClick = () => {
    if (!isDisabled && onChange) {
      onChange(!isSelected);
    }
  };

  return (
    <div
      className={`${styles.customCheckbox} ${
        isSelected ? styles.selected : ''
      } ${isDisabled ? styles.disabled : ''}`}
      onClick={handleClick}
      role="checkbox"
      aria-checked={isSelected}
      aria-disabled={isDisabled}
      tabIndex={isDisabled ? -1 : 0}
      onKeyDown={e => {
        if (!isDisabled && (e.key === 'Enter' || e.key === ' ')) {
          e.preventDefault();
          handleClick();
        }
      }}
    >
      {isSelected && (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="10"
          height="10"
          viewBox="0 0 10 10"
          fill="none"
        >
          <path
            d="M3.66706 9.07399C3.38239 9.07399 3.11237 8.94802 2.92976 8.7283L0.752512 6.11599C0.413152 5.70876 0.467842 5.10328 0.875072 4.76443C1.28327 4.42654 1.88777 4.47927 2.22712 4.88748L3.64509 6.58865L7.75691 1.35525C8.08552 0.937275 8.68757 0.867945 9.10505 1.19314C9.52155 1.52029 9.59431 2.1238 9.26667 2.5408L4.42194 8.70682C4.24274 8.93534 3.97077 9.0701 3.68073 9.07401L3.66706 9.07399Z"
            fill="white"
          />
        </svg>
      )}
    </div>
  );
};

export default MenuCheckbox;
